import { ShieldCheckIcon, LockClosedIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import logo from "../assets/logoNA.svg";
export default function PrivacyPolicy() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-900 via-sky-500 to-white">
            <nav className="fixed w-full bg-white/90 backdrop-blur-lg shadow-lg z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-20"> {/* Increased height */}
                        <div className="flex-shrink-0 flex items-center space-x-3">
                        <div className="relative w-16 h-16">
                                <img src={logo} alt='' />
                            </div>
                            <a href='/' className="text-3xl p-0 m-0 font-bold bg-gradient-to-r from-blue-900 to-sky-600 bg-clip-text text-transparent no-underline leading-tight pb-1">
                                NexusAgents
                            </a>
                        </div>

                        {/* Desktop Menu - Increased text size */}
                        <div className="hidden md:flex space-x-8">
                            <a href="services" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Services</a>
                            <a href="how" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">How It Works</a>
                            <a href="contact" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Contact</a>
                        </div>
                        {/* <a href="login" className="hidden md:flex bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a>
                        <a href="login" className="md:hidden bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a> */}

                        {/* Mobile Menu Button - Larger size */}
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="md:hidden p-3 rounded-lg text-blue-900 hover:bg-sky-50"
                        >
                            <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Menu - Larger text */}
                {isMenuOpen && (
                    <div className="md:hidden px-4 pt-2 pb-4 space-y-2">
                        <a href="services" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Services</a>
                        <a href="how" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">How It Works</a>
                        <a href="contact" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Contact</a>
                    </div>
                )}
            </nav>
            <div className="py-32 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
                <div className="text-center mb-12">
                    <ShieldCheckIcon className="h-16 w-16 text-sky-300 mx-auto mb-4" />
                    <h1 className="text-4xl font-bold text-white mb-2">Privacy Policy</h1>
                    <p className="text-sky-200 text-lg">Effective Date: [1st May 2025]</p>
                </div>

                <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-xl p-8 sm:p-12">
                    <div className="prose max-w-none">
                        <h2 className="text-2xl font-semibold text-blue-900 mb-4">1. Information We Collect</h2>
                        <p className="text-gray-700 mb-6">
                            We collect information to provide better services to our users:
                        </p>
                        <ul className="list-disc pl-6 space-y-2 mb-8">
                            <li>Account Information (name, email, phone number)</li>
                            <li>Service-related details (delivery addresses, shopping lists)</li>
                            <li>Payment information processed through secure third-party gateways</li>
                            <li>Technical data (IP address, device information, usage patterns)</li>
                        </ul>

                        <h2 className="text-2xl font-semibold text-blue-900 mb-4">2. How We Use Information</h2>
                        <div className="grid md:grid-cols-2 gap-8 mb-8">
                            <div className="p-4 bg-sky-50 rounded-lg">
                                <LockClosedIcon className="h-8 w-8 text-sky-600 mb-2" />
                                <h3 className="font-semibold mb-2">Service Operations</h3>
                                <p className="text-sm">Order processing, delivery coordination, and customer support</p>
                            </div>
                            <div className="p-4 bg-sky-50 rounded-lg">
                                <DocumentTextIcon className="h-8 w-8 text-sky-600 mb-2" />
                                <h3 className="font-semibold mb-2">Improvements</h3>
                                <p className="text-sm">Enhancing service quality and developing new features</p>
                            </div>
                        </div>

                        <h2 className="text-2xl font-semibold text-blue-900 mb-4">3. Data Protection</h2>
                        <p className="text-gray-700 mb-4">
                            We implement security measures including:
                        </p>
                        <ul className="list-disc pl-6 space-y-2 mb-8">
                            <li>SSL encrypted communication</li>
                            <li>Regular security audits</li>
                            <li>Limited access to personal data</li>
                            <li>Secure payment processing partners</li>
                        </ul>

                        <h2 className="text-2xl font-semibold text-blue-900 mb-4">4. User Rights</h2>
                        <p className="text-gray-700 mb-4">
                            You have the right to:
                        </p>
                        <div className="grid gap-4 md:grid-cols-2 mb-8">
                            <div className="p-4 border border-sky-100 rounded-lg">
                                <h3 className="font-semibold mb-2">Access & Correction</h3>
                                <p className="text-sm">Review and update your personal information</p>
                            </div>
                            <div className="p-4 border border-sky-100 rounded-lg">
                                <h3 className="font-semibold mb-2">Data Deletion</h3>
                                <p className="text-sm">Request deletion of non-essential data</p>
                            </div>
                        </div>

                        <h2 className="text-2xl font-semibold text-blue-900 mb-4">5. Policy Updates</h2>
                        <p className="text-gray-700 mb-8">
                            We may update this policy periodically. Continued use of services constitutes acceptance of changes.
                        </p>

                        <div className="bg-sky-50 p-6 rounded-lg">
                            <h3 className="text-lg font-semibold text-blue-900 mb-2">Contact Us</h3>
                            <p className="text-gray-700">
                                For privacy concerns: <br />
                                Email: nexusagents123@gmail.com<br />
                                Phone: +91 8957637670<br />
                                Address: 60-ft Road, Kareli, Prayagraj-211016
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="py-16 bg-gradient-to-r from-blue-900 to-sky-600">
                {/* <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">  </div> */}
                <div className="w-full grid md:grid-cols-3 gap-8 mx-auto my-5 text-center px-4 sm:px-6 lg:px-8">
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6 text-center">About NexusAgents</h2>
                        <p className="text-sky-100 mb-8 text-xl text-justify">
                            {/* At NexusAgents, we bridge the gap between busy lives and everyday necessities. As your trusted local service partner, we specialize in secure doorstep deliveries, personalized shopping assistance, and hassle-free errand management. Our network of vetted professionals combines tech-driven efficiency with human-centric care, handling everything from urgent document transfers to meticulous grocery runs. Beyond physical tasks, we empower businesses with administrative support and tech consultations, ensuring both homes and enterprises thrive. With transparent pricing, real-time tracking, and a commitment to reliability, we transform time-consuming chores into seamless experiences. NexusAgents isn’t just a service—it’s your extended team, redefining convenience in the modern world. */}
                            We’re your hyperlocal solution hub, offering secure transfers, deliveries, personal shopping, and errand services for busy lives. With tech-driven agents and vetted pros, we simplify tasks from grocery runs to business paperwork. Trusted reliability, transparent pricing—we turn chores into effortless moments.
                        </p>
                    </div>
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6">Features</h2>
                        <ul className="list-unstyled space-y-4 text-center" aria-label="Quick links">
                            {/* <li><a href="refund" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Refund Policy</a></li> */}
                            <li><a href="terms" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Terms of Service</a></li>
                            <li><a href="privacy" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6">Ready to Experience Convenience?</h2>
                        <p className="text-sky-100 mb-8 text-xl">Join hundreds of satisfied customers today!</p>
                        <div className="flex justify-center space-x-4">
                            {/* <a href='register' className="bg-white no-underline text-blue-900 px-8 py-3 rounded-full font-semibold hover:bg-sky-50 transition-colors">
                                Sign Up Now
                            </a> */}
                            <a href='contact' className="border-2 border-white no-underline text-white px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-colors">
                                Contact Us
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-blue-900 text-sky-100 py-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p>Copyright © 2025 NexusAgents. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
}